import { zones } from 'mailup-react-helpers'
import {
  Chip,
  Grid,
  GRID_VARIANT_VERTICAL_BIG,
  GridCell,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  PanelCollapsible,
  SPACING_8,
  SpacingVertical,
  Text,
  Title,
  TITLE_VARIANT_S
} from 'mailup-web-components'
import { changeWizardStepCallback } from 'Pages/Task/recoil/callbacks/callbacks'
import {
  dynamicFieldState,
  recapState,
  tagsListState,
  taskState
} from 'Pages/Task/recoil/state/task'
import React from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

const InfoGeneral = () => {
  const intl = useIntl()
  const task = useRecoilValue(taskState)
  const { tagsList } = useRecoilValue(tagsListState)
  const [{ infoExpanden }, setRecapState] = useRecoilState(recapState)
  const dynamicField = useRecoilValue(dynamicFieldState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  const onCanchePanel = () => {
    setRecapState((prev) => ({
      ...prev,
      infoExpanden: !prev.infoExpanden
    }))
  }

  const goToStep = () => {
    changeWizardStep(1)
  }

  return (
    <PanelCollapsible
      title={intl.formatMessage({ id: 'Load.Task.Step1InfoGeneral' })}
      collapsed={!infoExpanden}
      onChange={onCanchePanel}
      beforeCollapseChildren={
        <Link
          data-mu-test='task-5-info-general'
          onClick={goToStep}
          variant={LINK_VARIANT_EXTRALIGHT}
        >
          {intl.formatMessage({ id: 'Load.Task.ReviewEdit' })}
        </Link>
      }
    >
      <Grid cols={3} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewTaskName' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>{task.Name}</Text>
        </GridCell>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewDefaultTimeZone' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>
            {task.CustomerTimeZone.split('.')[0] +
              ' ' +
              zones[task.CustomerTimeZone]}
          </Text>
        </GridCell>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Common.Tag' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          {task.Tags.map((item, key) => (
            <React.Fragment key={key}>
              {tagsList.find((f) => item === f.Id) && (
                <Chip
                  key={key}
                  label={
                    tagsList.find((f) => item === f.Id) &&
                    tagsList.find((f) => item === f.Id).Name
                  }
                />
              )}
            </React.Fragment>
          ))}
          {task.Tags.length === 0 && '-'}
        </GridCell>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewDescription' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>{task.Description ? task.Description : '-'}</Text>
        </GridCell>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewCustomTimeZone' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>
            {task.Detail.IdFieldUTCCode > 0
              ? intl.formatMessage({ id: 'Load.MailupCommon.Yes' }) +
                ' (' +
                (dynamicField.filter(
                  (f) => f.value === task.Detail.IdFieldUTCCode
                ).length > 0
                  ? dynamicField
                      .find((f) => f.value === task.Detail.IdFieldUTCCode)
                      .label.split('-')[1]
                  : '-') +
                ' )'
              : intl.formatMessage({ id: 'Load.MailupCommon.No' })}
          </Text>
        </GridCell>
      </Grid>
    </PanelCollapsible>
  )
}

export default InfoGeneral
